function getCircuitUUIDFromObjectUUID(uuid_object, mapping_array) {
  return mapping_array?.filter((d) => d.uuid_object === uuid_object)?.at(0)
    ?.uuid_circuit;
}

export { getCircuitUUIDFromObjectUUID };
